import { BasePackage } from './package';
import { Product } from './product';

export class RefundItemUnit {
  constructor(data) {
    this.assignee = data.assignee;
    this.id = data.id;
    this.isRefunded = data.isRefunded;

    /** @type {BasePackage} */
    this.package = data.package;

    /** @type {Product} */
    this.product = data.package;
  }
}

export class Refund {
  constructor(data) {
    this.id = data.id;
    this.approvedDate = data.approvedDate;
    this.amount = data.amount;

    /** @type {RefundItemUnit[]} */
    this.itemUnits = data.itemUnits;
    this.checkNumber = data.checkNumber;
    this.isCheckType = data.isCheckType;
  }
}
